export default {
    //整数
    numberValidator(rule, value, callback) {
        if (value.match(new RegExp("^[0-9]+$"))) {
            callback();
        } else {
            callback(new Error('只能输入数字'));
        }
    },
    //空字符串或整数
    numberValidatorNotRequired(rule, value, callback) {
        value = value || '';
        if (value.match(new RegExp("^$|^-?[0-9]+$"))) {
            callback();
        } else {
            callback(new Error('只能输入数字'));
        }
    },
    //包含2位小数的浮点数
    floatValidator(rule, value, callback) {
        if (value.match(new RegExp("^-?[0-9]*([\.][0-9]{2})$"))) {
            callback();
        } else {
            callback(new Error('只能输入包含2位小数的浮点数'));
        }
    },
    
    //空字符串或包含2位小数的浮点数
    floatValidatorNotRequired(rule, value, callback) {
        value = value || '';
        if (value.match(new RegExp("^$|^-?[0-9]*([\.][0-9]{2})$"))) {
            callback();
        } else {
            callback(new Error('只能输入包含2位小数的浮点数'));
        }
    },










    
    //整数或包含1-2位小数的浮点数
    floatValidator_12(rule, value, callback) {
        if (value.match(new RegExp("^[1-9][0-9]*([\.][0-9]{1,2})?$"))) {
            callback();
        } else {
            callback(new Error('只能输入整数或包含1-2位小数的浮点数'));
        }
    },
    //空字符串或整数或包含1-2位小数的浮点数
    floatValidatorNotRequired_12(rule, value, callback) {
        value = value || '';
        if (value.match(new RegExp("^$|^-?[1-9][0-9]*([\.][0-9]{1,2})?$"))) {
            callback();
        } else {
            callback(new Error('只能输入整数或包含1-2位小数的浮点数'));
        }
    },
}
